import { render, staticRenderFns } from "./InfoTiles.vue?vue&type=template&id=23a59e6e&scoped=true"
import script from "./InfoTiles.vue?vue&type=script&lang=js"
export * from "./InfoTiles.vue?vue&type=script&lang=js"
import style0 from "./InfoTiles.vue?vue&type=style&index=0&id=23a59e6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a59e6e",
  null
  
)

export default component.exports